import React, { FC, MouseEventHandler, ReactNode } from 'react';
import AnimationExpand from '../../animations/animation-expand/animation-expand';
import AnimationToggleRotate from '../../animations/animation-toggle-rotate/animation-toggle-rotate';
import IcomoonIcon from '../icomoon-icon/icomoon-icon';

interface Props {
  readonly active: boolean;
  readonly children: ReactNode;
  readonly heading: string;
  readonly onClick: MouseEventHandler<HTMLButtonElement>;
}

const AccordionItem: FC<Props> = ({
  active,
  children,
  heading,
  onClick,
}: Props) => (
  <div className="flex flex-col my-2">
    <button
      className={
        `${active ? 'bg-french-blue' : 'bg-grey-50'} ` +
        'duration-400 flex items-center justify-between focus:outline-none px-6 py-4 rounded-lg transition-colors w-full z-20'
      }
      onClick={onClick}
      type="button"
    >
      <h6
        className={
          `${active ? 'text-white' : 'text-black'} ` +
          'duration-400 mr-4 page-heading-six text-left transition-colors'
        }
      >
        {heading}
      </h6>

      <AnimationToggleRotate degrees={45} isRotated={active}>
        <IcomoonIcon
          className="duration-400 transition-colors"
          color={active ? 'white' : 'french-blue'}
          name="add"
          size="md"
        />
      </AnimationToggleRotate>
    </button>

    <AnimationExpand
      className="bg-light-blue rounded-b-lg transform -translate-y-2 z-10"
      isExpanded={active}
    >
      <div className="pb-4 pt-6 px-6">{children}</div>
    </AnimationExpand>
  </div>
);

export default AccordionItem;
